import AppResource from 'general/constants/AppResource'
import { useCallback, useEffect, useRef, useState } from 'react'
import KTFormGroup from 'general/components/Forms/KTFormGroup'
import { t } from 'i18next'
import _ from 'lodash'
import { thunkGetTaxAuthority2025 } from 'features/System/systemSlice'
import { useDispatch } from 'react-redux'
import DraggableModal from '../DragableModal/DraggableModal'
import useRouter from 'hooks/useRouter'
import { useAppSelector } from 'hooks/useRedux'
import { selectFormatNumber } from 'features/System/screens/SystemConfiguration/SystemConfigurationSlice'
// import DraggableModal from '../../DraggableModal'

export const ModalNotifyNumberFormat = (props) => {
  const { show, setShow, company, formatNumber } = props
  const [childrenModal, setChildrenModal] = useState({})

  const ref = useRef(null)
  const dispatch = useDispatch()
  const { navigate } = useRouter()
  return (
    <>
      <DraggableModal
        isOpen={show}
        setShow={(val) => {
          setShow(val)
        }}
        handleApplyChanges={() => {
          setShow(false)
          navigate('/hoa-don-dau-ra/he-thong/cau-hinh')
        }}
        hasCancelButton={true}
        ref={ref}
        width={'40rem'}
        applyText="Cập nhật ngay"
        cancelText="Để sau"
        onOpenChange={() => {
          setShow(false)
        }}
      >
        <div className="d-flex justify-content-start p-5">
          <img
            src={AppResource.images.notifycationModal.imgChangeCompanyType}
            alt="Change VAT For Fuel"
            style={{ display: 'block', margin: '0 auto' }}
          />
        </div>
        <div display="flex" className="w-full">
          <p
            className="text-center"
            style={{ fontSize: '16px', fontWeight: '600' }}
          >
            Thông báo quan trọng về việc cấu hình số thập phân
          </p>
          <p style={{ fontSize: '14px', fontWeight: '400' }}>
            Phần cấu hình định dạng số của bạn đang chưa đúng làm ảnh hưởng đến
            hiển thị số tiền trên hóa đơn. Quý khách vui lòng liên hệ hotline
            <b> 19000099</b> để thiết lập lại.
          </p>
        </div>
      </DraggableModal>
    </>
  )
}
